import React, {useEffect} from 'react';
import {useMenu} from '../../../hooks/useMenu';
import GuidedConfiguration from './guided-config';
import styles from './self-test.module.css';

function SelfTest() {
  const {onComponent} = useMenu();
  const {top, topText, container} = styles;

  useEffect(() => {
    setTimeout(() => {
      onComponent(<GuidedConfiguration />);
    }, 3000);
  }, []);

  return (
    <div>
      <div className={top}>
        <span className={topText}>Performing Self Test...</span>
      </div>
      <div className={container}>
        <table>
          <tr>
            <td>Tag</td>
            <td>0x19, 0x4B</td>
          </tr>
          <tr>
            <td>Transmitter Software</td>
            <td>2.00</td>
          </tr>
          <tr>
            <td>Enhanced Core</td>
            <td>4.60</td>
          </tr>
        </table>
      </div>
    </div>
  );
}

export default SelfTest;
